module.exports = __webpack_public_path__ + "img/WAVEBREAKER_SR_001_2048x2048.b938d5a6.png";